import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch, onBeforeMount } from 'vue'
import { cloneDeep } from 'lodash-es'
import { message as DcMessage } from '@dc-platform/dc-components'
import type { FormInstance } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import { exportList } from '@/api/common'
import { useI18n } from 'vue-i18n'
import { selectForNumberValidate } from '@/utils/validate'


const __default__ = { name: 'ExportDetails' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  search: {
    type: Object,
    default: () => {
      return {}
    }
  },
  taskTypeEnum: {
    type: Object
  },
  appId: {
    type: String
  }
},
  setup(__props, { expose: __expose }) {

const { t } = useI18n()

const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const initForm = { taskId: -9 }
const dataForm = ref(cloneDeep(initForm))
const formRules: Record<string, Rule[]> = {
  taskId: [{ required: true, validator: selectForNumberValidate, message: '请选择文件类型' }]
}

const props = __props

watch(
  () => visible.value,
  (val) => {
    if (!val) {
      formRef.value?.resetFields()
      dataForm.value = cloneDeep(initForm)
    }
  }
)

const handleOk = () => {
  formRef.value?.validate().then(() => {
    const { pageNumber, pageSize, ...other } = props.search

    exportList({
      appId: props.appId,
      taskType: dataForm.value.taskId,
      query: other
    })
      .then((res) => {
        DcMessage.success(t('tips.exportSuccess'))
      })
      .finally(() => {
        loading.value = false
        visible.value = false
      })
  })
}
const handleCancel = () => {
  formRef.value?.resetFields()
}

const init = () => {
  visible.value = true
}

__expose({ init })

return (_ctx: any,_cache: any) => {
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    title: "导出明细",
    width: "500px",
    "confirm-loading": loading.value,
    onOk: handleOk,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        model: dataForm.value,
        ref_key: "formRef",
        ref: formRef,
        rules: formRules,
        "wrapper-col": { span: 24 }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_dc_form_item, {
            name: "taskId",
            label: "文件类型",
            span: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosSelect, {
                value: dataForm.value.taskId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.value.taskId) = $event)),
                options: props.taskTypeEnum,
                allowClear: ""
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible", "confirm-loading"]))
}
}

})